import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import React, { useState, useEffect, useContext, useCallback } from "react";
import {Button,Table,Space,Dropdown,notification,Tooltip, Modal, Select} from "antd";
import { DeleteOutlined, EditOutlined, DownOutlined, PauseCircleOutlined, CloseCircleOutlined, 
  ForwardOutlined, SubnodeOutlined, PaperClipOutlined, DownCircleOutlined, UpCircleOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import GlobalContext from "../utils/GlobalContext";
import LoadingModal from "../utils/LoadingModal";
import MeetingInformation from "../components/MeetingInformation";
import AddMeetingPointsTable from "../pages/AddMeetingPointsTable";
import MeetingForm from "../components/Forms/MeetingForm";
import AgreementActionForm from "../components/Forms/AgreementActionForm";
import AgreementDecisionForm from "../components/Forms/AgreementDecisionForm";
import MeetingNewPointsForm from "../components/Forms/MeetingNewPointsForm";
import formatTimestamp from "../utils/FormatTimestamp";
import { Link } from "react-router-dom";
import { CLASSIFICATIONS, STATUS_POINT, AGREEMENTS, MEETING_STATUS } from "../utils/Constants";
// import { getRoleIntoMeeting } from "../utils/GetRoleIntoMeeting";
const PAGE_SIZE = 15;
const { Option } = Select;

const MeetingExecute = () => {
  const globals = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });

  // const [role, setRole] = useState(null);
  const userEmail = globals.userEmail;

  //Aqui estan todos los puntos de reunion ************************
  const [dataPoints, setDataPoints] = useState([]);
  
  //Para editar la meeting ****************************************
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [isEditMeeting, setIsEditMeeting] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [nextMeetings, setNextMeetings] = useState([]);
  // const [currentNextMeeting, setCurrentNextMeeting] = useState(null);
  
  //Para editar los puntos de reunion *******************************
  const [isEditPoint, setIsEditPoint] = useState(false);
  const [showMeetingPointsForm, setShowMeetingPointsForm] = useState(false);
  const [currentPointDetails, setCurrentPointDetails] = useState(null);
  const [showAddMeetingPoints, setShowAddMeetingPoints] = useState(false);

  //para agregar acuerdos ******************************************
  const [showAddAgreementDecision, setShowAddAgreementDecision] = useState(false);
  const [showAddAgreementAction, setShowAddAgreementAction] = useState(false);
  const [isEditAgreement, setIsEditAgreement] = useState(false);
  const [currentAgreement, setCurrentAgreement] = useState(null);

  //variables para mostrar los subpuntos
  const [showSubPoints, setShowSubPoints] = useState(false);
  const [currentParentPoint, setCurrentParentPoint] = useState(null);
  const [dataSubPoints, setDataSubPoints] = useState([]);


  const { id } = useParams();
  const isMeetingClosed = currentMeeting?.statusId === MEETING_STATUS.FINALIZADA || currentMeeting?.statusId === MEETING_STATUS.CANCELADA;
  const isOwner = currentMeeting?.creator === userEmail;
  const isCohost = currentMeeting?.co_host === userEmail;

  const columnsPoints = [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (_, record) => {
        if (record?.childPoints?.length > 0) {
          return (
            <Link onClick={() => {
              setShowSubPoints(true);
              setCurrentParentPoint(record);
              fetchSubPointsData(record.id);
            }}>
              {record?.name}
            </Link>
          )
        }
        else{
          return (
            <span>{record?.name}</span>
          )
        }
        
      },
    },
    {
      title: "Doc. Ref",
      dataIndex: "docref",
      key: "docref",
      width: 50,
      render: (_, record) => {
        if (record?.attach_files?.length > 0) {
          const menuAttachments = {
            items: [],
            onClick: ({ key }) => {
              window.open(key, "_blank");
            }
          }
          for (const file of record.attach_files) {
            const item = {
              key: file.url,  
              label: file.name,
              icon: <PaperClipOutlined />,
            }
            menuAttachments.items.push(item);
            
          };
          return (
            <Dropdown menu={menuAttachments}>
              <Button icon={<PaperClipOutlined />} shape="circle" />
            </Dropdown>
          )
        }
        return (
          <span></span>
        )
      },
    },
    {
      // title: "Tipo / Clasificación",
      title: "Clasificación",
      dataIndex: "point_type_name",
      key: "point_type",
      width: 100,
      render: (_, record) => {
        // return `${record?.point_type_name} / ${record?.classification?.name}`;
        return (
          <Tooltip title={record?.point_type_name}>
            {record?.classification?.name}
          </Tooltip>
        );
      }
    },
    {
      title: "Responsable",
      dataIndex: "responsible",
      key: "responsible",
      width: 120,
      render: (_, record) => {
        const email = record?.responsible;
        if (!email) {
          return <span>&lt;Sin Responsable&gt;</span>;
        }
      
        const username = email.split('@')[0];
      
        return (
          <Tooltip title={email}>
            {username}@...
          </Tooltip>
        );
      }
    },
    {
      title: "🕑",
      dataIndex: "duration",
      key: "duration",
      width: 50,
      render: (text) => {
        return (text) ? `${text} min` : `0 min`;
      },
    },
    {
      title: "Status",
      dataIndex: "statusMeetingPointDetailId",
      key: "statusMeetingPointDetailId",
      width: 150,
      render: (_, record) => {
        let text = "";
        if (record?.statusMeetingPointDetailId === STATUS_POINT.REAGENDADO) {
          // get in nextMeeting with id
          const nextMeeting = nextMeetings.find(meeting => meeting.id === record.next_meeting_Id);
            const nextMeetingDate = nextMeeting ? formatTimestamp(nextMeeting.startDate) : "<sin fecha>";
            text = (
            <Tooltip title={`Próxima reunión: ${nextMeetingDate}`}>
              <Link>
              {record.status_meeting_point_detail?.status_name}
              </Link>
            </Tooltip>
            )
        }
        else{
          text = (record?.statusMeetingPointDetailId === "" || record?.statusMeetingPointDetailId === null) ? "<sin status>" : record.status_meeting_point_detail?.status_name;
        }
        return (
          <span>
            <span
              style={{marginRight: "8px"}}
            >
            <Dropdown
              style={{ marginLeft: "16px" }}
              trigger={["click"]}
              disabled={isMeetingClosed}
              menu={{
                items: [
                  {
                    key: "1",
                    label: "Abierto",
                    icon: <EditOutlined />,
                    onClick: () => handleStatusClick(STATUS_POINT.ABIERTO, record),
                  },
                  ...(currentMeeting?.periodicity_group_id !== null ? [
                  {
                    key: "2",
                    label: "Reagendado",
                    icon: <ForwardOutlined />,
                    onClick: () => handleStatusClick(STATUS_POINT.REAGENDADO, record),
                  },
                  {
                    key: "3",
                    label: "Suspendido",
                    icon: <PauseCircleOutlined />,
                    onClick: () => handleStatusClick(STATUS_POINT.SUSPENDIDO, record),
                  },
                  ] : []),
                  {
                    key: "4",
                    label: "Cerrado",
                    icon: <CloseCircleOutlined />,
                    onClick: () => handleStatusClick(STATUS_POINT.CERRADO, record),
                  },
                ],
              }}
            >
              <Button icon={<DownOutlined />} shape="circle" />
            </Dropdown>
            </span>
            {text}
          </span>
        )
      },
    },
    {
      title: "Acuerdo",
      dataIndex: ["agreements_meeting_point_detail", "agreements_name"],
      key: "agreementsMeetingPointDetailId",
      width: 170,
      render: (_, record) => {
        if (record?.classificationId === CLASSIFICATIONS.INFORMACION) {
          return (
            <span>&lt;no aplica&gt;</span>
          )
        }
        if (record?.agreementsMeetingPointDetailId === AGREEMENTS.CON_ACUERDO_ACCION || record?.agreementsMeetingPointDetailId === AGREEMENTS.APROBADO_DECISION) {
          return (
            <Link onClick={() => handleShowAgreement(record)}>
              {record?.agreements_meeting_point_detail?.agreements_name}
            </Link>
          )
        }
        if (!record?.statusMeetingPointDetailId || record?.statusMeetingPointDetailId === STATUS_POINT.ABIERTO) {
          const menu = {
            items: [
              {
                key: "1",
                label: "Crear nuevo acuerdo",
                icon: <UpCircleOutlined />,
                onClick: () => {showNewAgreement(record)},
              },
              {
                key: "2",
                icon: <DownCircleOutlined />,
                label: (record?.classificationId === CLASSIFICATIONS.DECISION) ? "No Aprobado" : "Sin Acuerdo",
                onClick: () => {handleNoAproved(record)},
              },

            ],
          }
          return (
            <div>
              <span 
                style={{marginRight: "8px"}}
              >{record.agreements_meeting_point_detail?.agreements_name || "EN BLANCO"}</span>
              <Dropdown menu={menu}>
                <Button>+</Button>
              </Dropdown>
            </div>

          )
        }
        else if (!record?.statusMeetingPointDetailId || record?.statusMeetingPointDetailId === STATUS_POINT.CERRADO) {
          const menu = {
            items: [
              {
                key: "1",
                label: "Crear nuevo acuerdo",
                icon: <UpCircleOutlined />,
                onClick: () => {showNewAgreement(record)},
              },
              {
                key: "2",
                icon: <DownCircleOutlined />,
                label: (record?.classificationId === CLASSIFICATIONS.DECISION) ? "No Aprobado" : "Sin Acuerdo",
                onClick: () => {handleNoAproved(record)},
              },

            ],
          }
          return (
            <div>
              <span 
                style={{marginRight: "8px"}}
              >{record.agreements_meeting_point_detail?.agreements_name || "EN BLANCO"}</span>
              <Dropdown menu={menu}>
                <Button>+</Button>
              </Dropdown>
            </div>

          )
        }
        else {
          return (
            <span>{record.agreements_meeting_point_detail?.agreements_name}</span>
          )
        }
      }
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      // width: 400
    },
    {
      title: <Tooltip title="Opciones"><span>Op</span></Tooltip>,
      key: "actions",
      width: 50,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "0",
                  label: "Agregar subpuntos",
                  icon: <SubnodeOutlined />,
                  onClick: () => handleActionClick("addSubPoint", record),
                },
                ...isMeetingClosed ? [] : [
                {
                  key: "1",
                  label: "Editar",
                  icon: <EditOutlined />,
                  onClick: () => handleActionClick("editPoint", record),
                },
                {
                  key: "2",
                  label: "Eliminar",
                  icon: <DeleteOutlined />,
                  onClick: () => handleActionClick("delete", record),
                },
              ],
              ],
            }}
          >
            <Button icon={<DownOutlined />} shape="circle" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const menuMinuta = {
    items: [
      {
        key: '1',
        label: 'Vista previa',
      },
      {
        key: '2',
        label: 'Enviar',
      },
    ],
    onClick: ({ key }) => {
      const owner = currentMeeting?.creator;
      const cohost = currentMeeting?.co_host;
      if (userEmail !== owner && userEmail !== cohost) {
        notification.warning({
          message: "Solo el dueño o co-anfitrión puede enviar la minuta",
          placement: "bottomRight",
          duration: 2,
        });
        return;
      }
      if (key === "1") {
        handlePreviewMinutes();
      } else if (key === "2") {
        handleSendMinutes();
      }
    }
  };

  const fetchCurrentMeeting = useCallback(
    async () => {
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/consult-meeting/${id}`,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        // const role = getRoleIntoMeeting(globals.userEmail, response?.data?.data);
        // setRole(role);
        console.log("meeting ****", response?.data?.data);
        setCurrentMeeting(response?.data?.data);  
      } catch (error) {
        console.log(error)
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -2) {
          setDataPoints([]);
        } else {
          notification.error({
            message: "Error obteniendo información de reunión!",
            placement: "bottomRight",
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  const fetchNewPointsData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
            },
          }
        );
        setDataPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          // notification.warning({
          //   message: "No hay información disponible!",
          //   placement: "bottomRight",
          //   duration: 2,
          // });
          setDataPoints([]);
        } else {
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  const fetchSubPointsData = useCallback(
    async (parentId, newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail-parentid`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              parentId: parentId,
            },
          }
        );
        console.log("subpoints ****", response?.data);
        setDataSubPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error fetching data:", error.response);
        notification.error({
          message: "Error obteniendo información!",
          placement: "bottomRight",
          duration: 2,
        });
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );
  
  const fetchNextMeetings = useCallback(async () => {
    try {
      if (!currentMeeting) return;
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-later-meeting/${currentMeeting?.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      console.log("next meetings ****", response?.data);
      setNextMeetings(response?.data?.data);
    } catch (error) {
      if (error?.response?.data?.status === -2){
        setNextMeetings([]);
        return;
      }
      console.error("Error fetching next meetings:", error);
      notification.error({
        message: "Error obteniendo siguientes reuniones",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token, currentMeeting]);

  useEffect(() => {
    fetchCurrentMeeting();
    fetchNewPointsData(null);
  }, [fetchCurrentMeeting, fetchNewPointsData]);

  useEffect(() => {
    fetchNextMeetings();
    // setCurrentNextMeeting(null);
  }, [currentMeeting, fetchNextMeetings]);

  const handleEditMeeting = () => {

    // if (moment(currentMeeting.startDate).isBefore(moment())){
    //   notification.warning({
    //     message: "No puedes editar reuniones pasadas",
    //     placement: "bottomRight",
    //     duration: 2,
    //   });
    //   return;
    // }
    if (currentMeeting.statusId === MEETING_STATUS.CANCELADA || currentMeeting.statusId === MEETING_STATUS.FINALIZADA){
      notification.warning({
        message: "No puedes editar reuniones cerradas o canceladas",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    setIsEditMeeting(true);
    setShowMeetingForm(true);
  };

  const handleStatusClick = async (status, record) => {
    let msg = "";
    let new_agreement = 1;
    const classification = record.classificationId;
    if (classification === CLASSIFICATIONS.INFORMACION) {
      
      new_agreement = AGREEMENTS.NO_APLICA_INFO;
      if (status === STATUS_POINT.ABIERTO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a ABIERTO?";
      }
      else if (status === STATUS_POINT.REAGENDADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a REAGENDADO?";
      }
      else if (status === STATUS_POINT.SUSPENDIDO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a SUSPENDIDO?";
      }
      else if (status === STATUS_POINT.CERRADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a CERRADO?";
      }
    }
    else if (classification === CLASSIFICATIONS.DECISION) {
      if (status === STATUS_POINT.ABIERTO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a ABIERTO? Cualquier acuerdo se eliminará y pasará a estado en blanco";
        new_agreement = AGREEMENTS.EN_BLANCO_DECISION;
      }
      else if (status === STATUS_POINT.REAGENDADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a REAGENDADO? Cualquier acuerdo se eliminará y pasará a estado diferido";
        new_agreement = AGREEMENTS.DIFERIDO_DECISION;
      }
      else if (status === STATUS_POINT.SUSPENDIDO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a SUSPENDIDO? Cualquier acuerdo se eliminará y pasará a estado en blanco";
        new_agreement = AGREEMENTS.EN_BLANCO_DECISION;
      }
      else if (status === STATUS_POINT.CERRADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a CERRADO?";
        if ([1, 2, 3, 5, 6, 7].includes(record.agreementsMeetingPointDetailId)) {
          new_agreement = record.agreementsMeetingPointDetailId;
        } else {
          new_agreement = AGREEMENTS.EN_BLANCO_DECISION
        }
      }
    }
    else if (classification === CLASSIFICATIONS.ACCION) {
      if (status === STATUS_POINT.ABIERTO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a ABIERTO? Cualquier acuerdo se eliminará y pasará a estado en blanco";
        new_agreement = AGREEMENTS.EN_BLANCO_ACCION;
      }
      else if (status === STATUS_POINT.REAGENDADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a REAGENDADO? Cualquier acuerdo se eliminará y pasará a estado diferido";
        new_agreement = AGREEMENTS.DIFERIDO_ACCION;
      }
      else if (status === STATUS_POINT.SUSPENDIDO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a SUSPENDIDO? Cualquier acuerdo se eliminará y pasará a estado en blanco";
        new_agreement = AGREEMENTS.EN_BLANCO_ACCION;
      }
      else if (status === STATUS_POINT.CERRADO) {
        msg = "Está seguro de cambiar el estado del punto de reunión a CERRADO?";
        new_agreement = record.agreementsMeetingPointDetailId;
        if (record.agreementsMeetingPointDetailId !== 6 && record.agreementsMeetingPointDetailId !== 7) {
          notification.warning({
            message: "No se puede cerrar un punto de acción sin acuerdos",
            placement: "bottomRight",
            duration: 4,
          });
          return;
        }
      }
    }
    let selectedNextMeeting = null;
    Modal.confirm({
      title: "Cambiar estado del punto de reunión",
      content: (status === STATUS_POINT.REAGENDADO) ? (
      <div>{msg}<br/><br/><span style={{ color: 'red' }}>* </span>Seleccione una próxima reunión:<br/>
        <Select 
        placeholder="Seleccione una próxima reunión"
        onChange={(value) => {
          selectedNextMeeting = value;
        }}
        >
        {nextMeetings.map((meeting) => (
          <Option key={meeting.id} value={meeting.id}>
          {formatTimestamp(meeting.startDate)}
          </Option>
        ))}
        </Select>
      </div>
      ) : msg,
      okText: "Cambiar",
      cancelText: "Cancelar",
      onOk: async () => {
      if (status === STATUS_POINT.REAGENDADO && !selectedNextMeeting) {
        notification.warning({
        message: "Por favor seleccione una próxima reunión",
        placement: "bottomRight",
        duration: 2,
        });
        return;
      }
      try {
        await axios.put(
        `${globals.SERVICE_API_DB}/v1/update-meeting-point-detail-agreement/${record.id}`,
        {
          statusMeetingPointDetailId: status,
          agreementsMeetingPointDetailId: new_agreement,
          classificationId: record.classificationId,
          next_meeting_Id: selectedNextMeeting,
        },
        {
          headers: {
          "x-token": globals.token,
          },
        }
        );
        if (showSubPoints) {
        fetchSubPointsData(currentParentPoint.id);
        }else{
        fetchNewPointsData(null);
        }
        // setCurrentNextMeeting(null);
        notification.success({
        message: "Estado actualizado exitosamente!",
        placement: "bottomRight",
        duration: 2,
        });
      } catch (error) {
        console.error("Error updating status:", error.response);
        notification.error({
        message: "Error actualizando estado!",
        placement: "bottomRight",
        duration: 2,
        });
      }
      },
      onCancel() {
      console.log("Cancel");
      },
    });
  }

  const handleNoAproved = async (record) => {

    if (currentMeeting.statusId === MEETING_STATUS.CANCELADA || currentMeeting.statusId === MEETING_STATUS.FINALIZADA){
      notification.warning({
        message: "No puedes cambiar el estado de un punto en una reunión cerrada o cancelada",
        placement: "bottomRight",
        duration: 4,
      });
      return;
    }

    const title = (record?.classificationId === CLASSIFICATIONS.DECISION) ? "Acuerdo no aprobado" : "Quiere dejar sin acuerdo el punto";
    Modal.confirm({
      title: title,
      content: "Esto cambiará el estado del punto de reunión a CERRADO",	
      okText: "Cambiar",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          await axios.put(
            `${globals.SERVICE_API_DB}/v1/update-meeting-point-detail-agreement/${record.id}`,
            {
              statusMeetingPointDetailId: STATUS_POINT.CERRADO,
              agreementsMeetingPointDetailId: (record?.classificationId === CLASSIFICATIONS.DECISION) ? AGREEMENTS.NO_APROBADO_DECISION : AGREEMENTS.SIN_ACUERDO_ACCION,
              classificationId: record.classificationId
            },
            {
              headers: {
                "x-token": globals.token,
              },
            }
          );
          if (showSubPoints) {
            fetchSubPointsData(currentParentPoint.id);
          }else{
            fetchNewPointsData(null);
          }
          notification.success({
            message: "Estado actualizado exitosamente!",
            placement: "bottomRight",
            duration: 2,
          });
        } catch (error) {
          console.error("Error updating status:", error.response);
          notification.error({
            message: "Error actualizando estado!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  }

  const handleActionClick = async (key, record) => {
    if (key === "editPoint") {
      setIsEditPoint(true);
      setCurrentPointDetails(record);
      setShowMeetingPointsForm(true);
    } else if (key === "delete") {
      Modal.confirm({
        title: 'Eliminar punto de reunión',
        content: '¿Está seguro de eliminar este punto de reunión?',
        okText: 'Eliminar',
        cancelText: 'Cancelar',
        onOk() {
          deletePointDetails(record)
        },
      });
    } else if (key === "addSubPoint") {
      setShowSubPoints(true);
      setCurrentParentPoint(record);
      fetchSubPointsData(record.id);
    }
  };

  const saveMeetingPointForm = async ({ status, newMeetingPoint }) => {
    setShowMeetingPointsForm(false);
    setCurrentPointDetails(null);
    if (isEditPoint) {
      setIsEditPoint(false);
      notification.success({
        message: "Punto de reunión editado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    if (status === "created") {
      if (currentParentPoint) {
        setDataSubPoints([newMeetingPoint, ...dataSubPoints]);
      } else {
        setDataPoints([newMeetingPoint, ...dataPoints]);
      }
    }

    notification.success({
      message: "Punto de reunión creado exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });

  };

  const saveMeetingForm = async ({ status, newMeeting }) => {
    setShowMeetingForm(false);
    if (isEditMeeting) {
      notification.success({
        message: "Reunión editada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      setCurrentMeeting(newMeeting);
      fetchCurrentMeeting();
      return;
    }
  };

  const closeMeetingForm = () => {
    setShowMeetingForm(false);
  };

  const closeMeetingPointForm = () => {
    setShowMeetingPointsForm(false);
    setIsEditPoint(false);
    setCurrentPointDetails(null);
  };

  const closeAddMeetingPointsTable = () => {
    setShowAddMeetingPoints(false);
    fetchNewPointsData(null);
  };

  const closeAddAgreement = () => {
    setShowAddAgreementDecision(false);
    setShowAddAgreementAction(false);
    setIsEditAgreement(false);
    setCurrentAgreement(null);
    fetchNewPointsData(null);
    if (showSubPoints) {
      fetchSubPointsData(currentParentPoint.id);
    }
  };

  const deletePointDetails = async (currentPointDetails) => {
    try {
      await axios.delete(
        `${globals.SERVICE_API_DB}/v1/delete-meeting-point-detail/${currentPointDetails.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setDataPoints(dataPoints.filter((item) => item.id !== currentPointDetails.id));
      setDataSubPoints(dataSubPoints.filter((item) => item.id !== currentPointDetails.id));
      notification.success({
        message: "Punto de reunión estándar eliminado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    } catch (err) {
      console.log(err.response.data);
      notification.error({
        message: "Error eliminando punto estándar",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
    fetchNewPointsData(newPagination);
  };

  const showNewAgreement = (record) => {
    if (record?.responsible !== userEmail && !isOwner && !isCohost && !record.agreement) {
      notification.warning({
        message: "Solo el responsable puede agregar acuerdos",
        placement: "bottomRight",
        duration: 4,
      });
      return;
    }
    setCurrentPointDetails(record);
    if (record.classificationId === CLASSIFICATIONS.DECISION) {
      setShowAddAgreementDecision(true);
    }
    else if (record.classificationId === CLASSIFICATIONS.ACCION) {
      setShowAddAgreementAction(true);
    }
  }

  const closeMeeting = async () => {
    try {
      setLoading(true);
      await axios.put(
        `${globals.SERVICE_API_DB}/v1/close-meeting/${id}`, 
        null,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setLoading(false);
      notification.success({
        message: "Reunión cerrada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      sendMinutes();
      fetchCurrentMeeting();
    }
    catch (error) {
      setLoading(false);
      console.error("Error closing meeting:", error.response);
      const status = error?.response?.data?.status; 
      let message = "Error cerrando reunión!";
      if (status === -3 || status === -4) {
        message = "No se puede cerrar debido a que hay puntos de reunión sin revisar";
      }
      if (status === -6) {
        message = "Esta es la última reunión del periodo, no se puede cerrar con puntos de reunión reagendados";
      }
      notification.error({
        message: message,
        placement: "bottomRight",
        duration: 4,
      });
    }
  };

  const previewMinutes = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-pdf-meeting-minutes`,
        {
          id: id,
        },
        {
          headers: {
            "x-token": globals.token,
          },
          responseType: "blob",
        }
      );
  
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
  
      // Abrir el PDF en una nueva pestaña
      window.open(url, "_blank");
  
      setLoading(false);
      notification.success({
        message: "Minuta enviada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    } catch (error) {
      setLoading(false);
      console.error("Error closing meeting:", error.response);
      // const status = error?.response?.data?.status; 
      let message = "Error enviando minuta!";
     
      notification.error({
        message: message,
        placement: "bottomRight",
        duration: 2,
      });
    }
  };
  
  
  const sendMinutes = async () => {
    try {
      setLoading(true);
      await axios.post(
        `${globals.SERVICE_API_DB}/v1/send-email-meeting-minutes`, 
        {
          id: id,
        },
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setLoading(false);
      notification.success({
        message: "Minuta enviada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      // fetchCurrentMeeting(); 
    }
    catch (error) {
      setLoading(false);
      console.error("Error closing meeting:", error.response);
      // const status = error?.response?.data?.status; 
      let message = "Error enviando minuta!";
     
      notification.error({
        message: message,
        placement: "bottomRight",
        duration: 2,
      });
    }
  };

  const handleShowAgreement = (record) => {
    setIsEditAgreement(true);
    setCurrentAgreement(record.agreement);
    showNewAgreement(record);
  }

  const handlePreviewMinutes = async () => {
    Modal.confirm({
      title: 'Visualizar minuta',
      content: '¿Está seguro que quiere visualizar la minuta de la reunión?',
      okText: 'Ver minuta',
      cancelText: 'Cancelar',
      onOk() {
        previewMinutes();
      },
    });
  };

  const handleSendMinutes = async () => {
    Modal.confirm({
      title: 'Enviar minuta',
      content: '¿Está seguro de enviar la minuta de la reunión?',
      okText: 'Enviar',
      cancelText: 'Cancelar',
      onOk() {
        sendMinutes();
      },
    });
  };

    const handleCloseMeeting = async () => {

      const isOwner = currentMeeting?.creator === userEmail;
      const isCohost = currentMeeting?.co_host === userEmail;

      if (!isOwner && !isCohost) {
        notification.warning({
          message: "Solo el dueño o co-anfitrión puede cerrar la reunión",
          placement: "bottomRight",
          duration: 2,
        });
        return;
      }

      Modal.confirm({
        title: 'Cerrar reunión',
        content: '¿Está seguro de cerrar esta reunión? Esta acción también enviará la minuta a los asistentes',
        okText: 'Cerrar',
        cancelText: 'Cancelar',
        onOk() {
          closeMeeting();
        },
      });
  };

  const handleRefresh = () => {
    fetchCurrentMeeting();
    if (showSubPoints) {
      fetchSubPointsData(currentParentPoint.id);
    }
    else{
      fetchNewPointsData(null);
    }
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <Button

          onClick={() => {
            window.history.back();
          }}
          style={{ marginRight: "8px" }}
        >
          Regresar
        </Button>
        <h2 style={{ marginRight: "16px", display: "flex", alignItems: "center" }}>
          <span style={{ 
            fontWeight: "bold",
            fontSize: "24px",
            color: "#4096FF",
            display: "flex",
            alignItems: "center",
            marginRight: "8px",
          }}>
            {(currentMeeting?.statusId === MEETING_STATUS.FINALIZADA) ? "Cerrada: ": "Ejecución: "}
          </span>
          <span>{currentMeeting?.title_meeting}</span>
        </h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Dropdown menu={menuMinuta}>
          <Button type="primary" style={{ marginRight: "8px" }}>
            Minuta <DownOutlined />
          </Button>
        </Dropdown>
        <Button
          onClick={handleCloseMeeting}	
          type="primary"
          danger
          style={{ marginRight: "8px"}}
          disabled={isMeetingClosed}
        >
          Cerrar Reunión
        </Button>
        
        <Button
          onClick={handleEditMeeting}
          style={{ marginRight: "8px" }}
          disabled={isMeetingClosed}
        >
          Editar
        </Button>
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <MeetingInformation meeting={currentMeeting} />
        {showSubPoints ? (     
          <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>  
            <Button
              onClick={() => {
                setShowSubPoints(false);
                setCurrentParentPoint(null);
                fetchNewPointsData(null);
              }}
              style={{ marginRight: "8px" }}
            >
              Regresar
            </Button> 
            <Tooltip title={currentParentPoint.description}>
              <h4 style={{ marginBottom: 16, display:"flex" }}>
              <span style={{ 
                color: "#4096FF",
                marginRight: "8px",
              }}>Subpuntos de: 
              </span>
                {currentParentPoint.name}
              </h4>
            </Tooltip>
            <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
            <Button
              type="primary"
              onClick={() => {
                setShowMeetingPointsForm(true);
              }}
              style={{ marginRight: "8px" }}
              disabled={currentMeeting?.statusId === MEETING_STATUS.CANCELADA || currentMeeting?.statusId === MEETING_STATUS.FINALIZADA}
            >
              Crear subpunto
            </Button>
          </div>
        ):(
          <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
            <h4 style={{ marginBottom: 16 }}>Puntos de reunión</h4>
            <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
            <Button
              type="primary"
              onClick={() => {
                setShowAddMeetingPoints(true);
              }}
              style={{ marginRight: "8px" }}
              disabled={isMeetingClosed}
            >
              Agregar
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setShowMeetingPointsForm(true);
              }}
              style={{ marginRight: "8px" }}
              disabled={isMeetingClosed}
            >
              Crear
            </Button>
          </div>
        )}
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
      {showSubPoints ? (
        <Table
          rowKey={(r) => uuidv4()}
          columns={columnsPoints}
          dataSource={dataSubPoints}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      ) : (
        <Table
          rowKey={(r) => uuidv4()}
          columns={columnsPoints}
          dataSource={dataPoints}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      )}
      </div>
      <LoadingModal open={loading} />

      <MeetingForm
        open={showMeetingForm}
        onFinish={saveMeetingForm}
        onCancel={closeMeetingForm}
        isEdit={isEditMeeting}
        currentMeeting={currentMeeting}
      />
      
      <MeetingNewPointsForm
        open={showMeetingPointsForm}
        onFinish={saveMeetingPointForm}
        onCancel={closeMeetingPointForm}
        isEdit={isEditPoint}
        currentMeetingNewPoint={currentPointDetails}
        currentMeeting={currentMeeting}
        currentParentPoint={currentParentPoint}
      />       

      <AgreementDecisionForm
        open={showAddAgreementDecision}
        onFinish={closeAddAgreement}
        onCancel={() => {
          setCurrentAgreement(null)
          setShowAddAgreementDecision(false); 
          setIsEditAgreement(false)
        }}
        isEdit={isEditAgreement}
        currentMeetingPointDetail={currentPointDetails}
        currentAgreement={currentAgreement}
        currentMeeting={currentMeeting}
        />

      <AgreementActionForm
        open={showAddAgreementAction}
        onFinish={closeAddAgreement}
        onCancel={() => {
          setCurrentAgreement(null)
          setShowAddAgreementAction(false); 
          setIsEditAgreement(false)
        }}
        isEdit={isEditAgreement}
        currentMeetingPointDetail={currentPointDetails}
        currentAgreement={currentAgreement}
        currentMeeting={currentMeeting}
        />

      <Modal
        open={showAddMeetingPoints}
        onCancel={closeAddMeetingPointsTable}
        footer={[
          <Button key="ok" type="primary" onClick={closeAddMeetingPointsTable}>
            Cerrar
          </Button>,
        ]}
        width={1000}
      >
        <AddMeetingPointsTable
          currentMeetingId={currentMeeting?.id}
          meeting_type_name={currentMeeting?.meeting_type_name}
          department_name={currentMeeting?.department_name}
        />
      </Modal>
    </div>
  );
};

export default MeetingExecute;
